import ChannelObject from '@/docs-partials/api/schema/channel-object.mdx';
import * as React from 'react';
export default {
  ChannelObject,
  React
};